export default "__VITE_ASSET__20668f6a__"